import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsActionAdminComponent } from './permissions-action-admin.component';
import { AddPermissionsActionAdminComponent } from './add-permissions-action-admin/add-permissions-action-admin.component';
import { EditPermissionsActionAdminComponent } from './edit-permissions-action-admin/edit-permissions-action-admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    PermissionsActionAdminComponent, 
    AddPermissionsActionAdminComponent, 
    EditPermissionsActionAdminComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule, 
  ],
  exports: [PermissionsActionAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PermissionsActionAdminModule { }
